<ul *ngIf="control.touched && !control.valid && !!getErrors().length" class="error-container">
    <li class="error-item" *ngFor="let error of getErrors()">{{error}}</li>
</ul>
